(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["social-sharing-extra"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-instagram-copy]');
    if (!button) return;
    const panel = button.closest('.instagram-share__panel');
    const input = panel.querySelector('[data-instagram-url]');
    const status = panel.querySelector('.instagram-share__status');
    try {
      if (!navigator.clipboard || !window.isSecureContext) throw new Error('clipboard unavailable');
      await navigator.clipboard.writeText(input.value);
      status.textContent = button.dataset.success;
    } catch {
      input.focus();
      input.select();
      status.textContent = button.dataset.fallback;
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.instagram-share[open]');
    if (!details) return;
    details.open = false;
    details.querySelector('summary').focus();
    event.stopPropagation();
  });
  } catch(e) { console.error(e); }
})();

})();
